import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {useHistory, useParams, useLocation} from 'react-router-dom';
import {connect} from 'react-redux';
import Option from '../components/common/Option';
import ProfileIdentityContent from '../components/Profile/ProfileIdentityContent';
import ProfileDevices from '../components/Profile/ProfileDevices';
import ProfileContracts from '../components/Profile/ProfileContracts';
import {fetchCustomer, updateCustomer, uploadCustomerDocument} from '../redux/actions/CustomersActions';
import ProfilePayments from '../components/Profile/ProfilePayments';
import ProfileRepresentatives from '../components/Profile/ProfileRepresentatives';
import {
    addCustomerDocument,
    getCustomerDocument,
    getCustomerDocuments,
    updateCustomerDocument
} from '../api/network/businessCustomerService';
import {DOCUMENT_TYPE} from '../const/documents';
import {downloadDocument, uploadDocument} from '../api/network/documentService';
import {getPriceTiers} from '../api/network/deviceService';

const ProfileWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;
`;

const ProfileNav = styled.div`
  background: #E2E8F0;
  max-width: 304px;;
  padding: 40px 24px 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Heading = styled.div`
    width: fit-content;
    font-family: Metropolis,serif;
    /* identical to box height, or 100% */
    display: flex;
    flex-direction: column;
    justify-content: start;
    margin-bottom: 16px;
    align-self: start;
    margin-left: 8px;
`;

const HeadingLink = styled.div`
    /* default/gray/100 */
    background-color: var(--color-gray-100);
    border-radius: 6px;
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */
    margin-bottom: 38px;
    padding: 8px;
    
    /* default/gray/600 */
    color: var(--color-gray-600);
    
    user-select: none;
    
    background-position: center;
    transition: background-color 0.8s;
    
    cursor:pointer;
    :hover {
      background: rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%;
    }
`;

const HeadingName = styled.div`
    /* text-lg/Medium */
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height, or 100% */
    margin-bottom: 12px;
    
    /* default/gray/800 */
    color: var(--color-gray-800);
`;

const HeadingCompanyName = styled.div`
    /* text-base/Medium */
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    /* default/gray/600 */
    color: var(--color-gray-600);
`;

const ProfileSectionSelectors = styled.div`
  display: grid;
  margin-top: 40px;
  grid-auto-flow: row;
  grid-row-gap: 16px;
`;

const ProfileContent = styled.div`
    width: 100%;
    height: 95%;
    
`;

export const profileSections = {
    Identity: 'Identity',
    Representatives: 'Representatives',
    // Letter_of_Undertaking: 'Letter of Undertaking',
    Contracts: 'Contracts',
    Devices: 'Devices',
    // Payments: 'Payments',
    // Invoices: 'Invoices'
};

const updateUserDocumentPromise = (companyId, customerId, documentId, documentTypeId, formData) => new Promise((resolve, reject) => {
    uploadDocument(formData)
        .then(result => {
            const params = {
                documentId: result.id,
                documentTypeId
            };

            if (documentId) {
                updateCustomerDocument(companyId, customerId, documentId, params)
                    .then(busResp => resolve(busResp))
                    .catch(err => reject(err));
            } else {
                addCustomerDocument(companyId, customerId, params)
                    .then(busResp => resolve(busResp))
                    .catch(err => reject(err));
            }
        })
        .catch(err => {
            reject(err);
        });
});

/***
 * CustomerProfile Page display and manage customer information.
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function CustomerProfile(props) {
    const {customers, fetchCustomer, saveCustomer, uploadCustomerDocument, auth} = props;
    const history = useHistory();
    const params = useParams();
    const location = useLocation();
    const customerId = params.customerSlug || false;
    const companyId = params.companySlug || false;

    const [customer, setCustomer] = useState({});
    const [updateCustomer, setUpdateCustomer] = useState({});
    const [docs, setDocs] = useState([]);
    const [tiers, setTiers] = useState([]);

    useEffect(() => {
        // the customer
        const selectedCustomer = customers.find(c => c.id === customerId);

        if (selectedCustomer) {
            setCustomer(selectedCustomer);
        } else {
            fetchCustomer(companyId, customerId);
        }
        setUpdateCustomer(customer);
    }, [companyId, customer, customerId, customers, fetchCustomer]);

    useEffect(() => {
        // eslint-disable-next-line no-shadow
        const {id, companyId, isIndividual} = customer || {};
        if (id && companyId) {
            // eslint-disable-next-line no-use-before-define
            fetchCustomerDocuments(companyId, id, isIndividual);
        }
        getPriceTiers()
            .then(result => {
                const priceTiers = [];
                Object.keys(result)
                    .map(key => priceTiers.push({tier: Number(key), ...result[key]}));
                setTiers([...priceTiers]);
            })
            .catch(error => console.error(`failed.price.tiers::${error}`));
    }, [customer]);

    const {state} = location;
    let initialSection = profileSections.Identity;
    if (state) {
        initialSection = state.section;
    }

    const [currentSection, setCurrentSection] = useState(initialSection);

    const handleOnUserSave = () => {
        const {trn, yearsOfBusiness} = updateCustomer;

        const customerToSave = {
            ...updateCustomer,
            trn: trn ? trn.toString()
                .replace(/ /g, '')
                .trim() : null,
            yearsOfBusiness: yearsOfBusiness ? Number(yearsOfBusiness.toString()
                .replace(/ /g, '')
                .trim()) : null
        };

        saveCustomer(updateCustomer.companyId, updateCustomer.id, customerToSave);

        // if (Object.keys(docs).length) {
        //     // docs exist to be saved
        //     Object.keys(docs).forEach(doc => {
        //         const formData = new FormData();
        //         formData.append('file', docs[doc]);
        //         formData.append('metadata', JSON.stringify({name: doc}));
        //
        //         uploadCustomerDocument(updateCustomer.companyId, updateCustomer.id, {
        //             name: doc,
        //             formData
        //         });
        //     });
        // }

        // updated customer documents.
        const docsToSavePromises = [];
        docs.forEach(item => {
            console.log('hello item', item);

            if (item.upload) {
                //docsToSave.push(item);

                const formData = new FormData();
                formData.append('file', item.upload.data);

                const promise = updateUserDocumentPromise(companyId, customerId, item.id, item.documentType?.id, formData);
                docsToSavePromises.push(promise);
            }
        });

        Promise.all(docsToSavePromises)
            .then(results => {
                console.log('promise all response', results);

                if (Array.isArray(results)) {
                    // eslint-disable-next-line no-restricted-syntax
                    // const defaultDocs = generateDefaultDocs(results, updateCustomer.isIndividual);
                    // console.log('default docs', defaultDocs);

                    const updatedDocs = [...docs];

                    // eslint-disable-next-line no-restricted-syntax
                    for (const result of results) {
                        const docType = result?.documentType?.id;
                        // eslint-disable-next-line no-restricted-syntax
                        for (const docsKey in updatedDocs) {
                            if (updatedDocs[docsKey].documentType?.id === docType) {
                                updatedDocs[docsKey] = result;
                                break;
                            }
                        }
                    }

                    setCustomerDocs(updatedDocs);
                }
            })
            .catch(err => {
                console.log('promise all faileed', err);
            });
    };

    const handleOnViewDocClick = document => {
        // eslint-disable-next-line no-shadow
        const {documentId} = document;

        downloadDocument(documentId, (error, result) => {
            console.log(error, result);
        });
    };

    const handleSectionSelection = section => {
        setCurrentSection(section);
        // update the section in browser location state
        history.replace(location.pathname, {section});
    };

    const handleOnUserFileChange = (event, docIndex) => {
        const {name, files} = event.target;
        const updates = [
            ...docs
        ];

        const doc = docs[docIndex];
        updates[docIndex] = {
            ...doc,
            upload: {
                data: files[0],
                name
            }
        };
        setDocs(updates);
    };

    const handleOnUserFieldChange = event => {
        const {name, value} = event.target;
        const updatedCustomer = {
            ...updateCustomer,
            [name]: value
        };
        setUpdateCustomer(updatedCustomer);
    };

    const backToCustomers = () => {
        history.push('/fulfillment/customers');
    };

    const getProfileSection = selection => {
        switch (selection) {
        case profileSections.Identity:
            return <ProfileIdentityContent
                key="Identity"
                {...updateCustomer}
                userRole={auth?.role}
                tiers={tiers}
                docs={docs}
                onSaveClick={handleOnUserSave}
                onFileChange={handleOnUserFileChange}
                onDocumentView={handleOnViewDocClick}
                onFieldChange={handleOnUserFieldChange}
            />;
        case profileSections.Representatives:
            return <ProfileRepresentatives customer={customer}/>;
        case profileSections.Letter_of_Undertaking:
            return null;
        case profileSections.Contracts:
            return <ProfileContracts/>;
        case profileSections.Devices:
            return <ProfileDevices/>;
        case profileSections.Payments:
            return <ProfilePayments/>;
        case profileSections.Invoices:
            return null;
        default:
            return null;
        }
    };

    // eslint-disable-next-line no-shadow
    const setCustomerDocs = docs => {
        const customerDocuments = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const i in docs) {
            // eslint-disable-next-line no-prototype-builtins, no-continue
            if (!docs.hasOwnProperty(i)) continue;

            const currentDoc = docs[i];
            const docType = currentDoc?.documentType?.id;
            switch (docType) {
            case DOCUMENT_TYPE.Certification_Of_Incorporation:
                currentDoc.title = 'Certification of Incorporation';
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Proof_of_Address:
                currentDoc.title = 'Proof of Address';
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Proof_of_Registration:
                currentDoc.title = 'Proof of Registration';
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Tax_Compliance_Certification:
                currentDoc.title = 'Tax Compliance Certificate';
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Proof_of_Income:
                currentDoc.title = 'Proof of income';
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Gov_ID:
                currentDoc.title = 'Government ID';
                customerDocuments.push(currentDoc);
                break;
                // case DOCUMENT_TYPE.Contracts:
                //     currentDoc.title = 'Contract';
                //     customerDocuments.push(currentDoc);
                //     break;
            default:
                break;
            }
        }

        setDocs(customerDocuments);
    };

    const generateDefaultDocs = (currentDocs = [], isIndividual) => {
        const customerDocuments = Array.isArray(currentDocs) ? [...currentDocs] : [];

        const businessDefaultDocs = [
            DOCUMENT_TYPE.Certification_Of_Incorporation,
            DOCUMENT_TYPE.Proof_of_Address,
            DOCUMENT_TYPE.Tax_Compliance_Certification,
            DOCUMENT_TYPE.Proof_of_Registration
        ];

        const individualDefaultDocs = [
            DOCUMENT_TYPE.Proof_of_Income,
            DOCUMENT_TYPE.Gov_ID,
            DOCUMENT_TYPE.Proof_of_Address
        ];

        // set default docs
        let defaultDocs = isIndividual ? individualDefaultDocs : businessDefaultDocs;
        // eslint-disable-next-line no-restricted-syntax
        for (const doc of customerDocuments) {
            const docType = doc?.documentType?.id;
            defaultDocs = defaultDocs.filter(item => item !== docType);
        }

        //eslint-disable-next-line no-restricted-syntax
        for (const defaultDoc of defaultDocs) {
            const currentDoc = {};

            switch (defaultDoc) {
            case DOCUMENT_TYPE.Certification_Of_Incorporation:
                currentDoc.title = 'Certification of Incorporation';
                currentDoc.documentType = {id: DOCUMENT_TYPE.Certification_Of_Incorporation};
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Proof_of_Address:
                currentDoc.title = 'Proof of Address';
                currentDoc.documentType = {id: DOCUMENT_TYPE.Proof_of_Address};
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Proof_of_Registration:
                currentDoc.title = 'Proof of Registration';
                currentDoc.documentType = {id: DOCUMENT_TYPE.Proof_of_Registration};
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Tax_Compliance_Certification:
                currentDoc.title = 'Tax Compliance Certificate';
                currentDoc.documentType = {id: DOCUMENT_TYPE.Tax_Compliance_Certification};
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Proof_of_Income:
                currentDoc.title = 'Proof of income';
                currentDoc.documentType = {id: DOCUMENT_TYPE.Proof_of_Income};
                customerDocuments.push(currentDoc);
                break;
            case DOCUMENT_TYPE.Gov_ID:
                currentDoc.title = 'Government ID';
                currentDoc.documentType = {id: DOCUMENT_TYPE.Gov_ID};
                customerDocuments.push(currentDoc);
                break;
            default:
                break;
            }
        }

        return customerDocuments;
    };

    const fetchCustomerDocuments = (companyId, customerId, isIndividual) => {
        getCustomerDocuments(companyId, customerId)
            .then(docs => {
                console.log('doc retrieved', docs);

                const defaultDocs = generateDefaultDocs(docs, isIndividual);
                setCustomerDocs(defaultDocs);
            })
            .catch(err => {
                console.log('failed to fetch customer documents', err);
            });
    };

    const {isIndividual} = customer;

    return (
        <ProfileWrapper>
            <ProfileNav>
                <Heading>
                    <HeadingLink onClick={backToCustomers}>Back to Customers</HeadingLink>
                    <HeadingName>{customer.companyName}</HeadingName>
                    <HeadingCompanyName>{customer.representativeName}</HeadingCompanyName>
                </Heading>

                <ProfileSectionSelectors>
                    {
                        Object.keys(profileSections)
                            .map(section => (
                                <Option
                                    key={section}
                                    name={profileSections[section]}
                                    isSelected={currentSection === section}
                                    warning={false}
                                    onSelected={() => handleSectionSelection(section)}
                                />
                            ))
                    }
                </ProfileSectionSelectors>
            </ProfileNav>

            <ProfileContent>
                {getProfileSection(currentSection)}
            </ProfileContent>

        </ProfileWrapper>
    );
}

CustomerProfile.propTypes = {};
CustomerProfile.defaultProps = {};

const mapDispatchToProps = {
    fetchCustomer,
    saveCustomer: updateCustomer,
    uploadCustomerDocument
};

const mapStateToProps = (state, props) => ({
    auth: state.auth,
    userData: state.user,
    userDocsData: state.govDocs,
    customers: state.customers,
});
export default connect(mapStateToProps, mapDispatchToProps)(CustomerProfile);
